import React, { createContext, useContext, useState, useCallback } from 'react';

const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
  const [alertMessage, setAlertMessage] = useState({ type: '', content: '' });
  const [currentUser, setCurrentUser] = useState();
  const [currentOrg, setCurrentOrg] = useState();
  const [currentProject, setCurrentProject] = useState();
  const [headerRefresh, setHeaderRefresh] = useState(false);
  const [requiresPayment, setRequiresPayment] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [welcomeOpen, setWelcomeOpen] = useState(false);
  
  // Unified modal state
  const [modalState, setModalState] = useState({ show: false, type: null });

  const triggerHeaderRefresh = () => {
    setHeaderRefresh(prevState => !prevState); // Toggle the state
  };

  const showAlertMessage = (type, content) => {
    setAlertMessage({ type, content });
  };

  const clearAlertMessage = () => {
    setAlertMessage({ type: '', content: '' });
  };

  // Unified modal management functions
  const openModal = useCallback((type, props = {}) => {
    setModalState({ show: true, type, ...props });
  }, []);

  const closeModal = useCallback(() => {
    setModalState({ show: false, type: null });
  }, []);

  const value = {
    currentUser,
    setCurrentUser,
    currentOrg,
    setCurrentOrg,
    currentProject,
    setCurrentProject,
    alertMessage,
    showAlertMessage,
    clearAlertMessage,
    headerRefresh,
    triggerHeaderRefresh,
    requiresPayment,
    setRequiresPayment,
    mobileNavOpen,
    setMobileNavOpen,
    welcomeOpen,
    setWelcomeOpen,
    
    // Modal management
    modalState,
    openModal,
    closeModal
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};